import PricingCard from '../pricing-card';

export default function PricingTab() {
    return (
        <div className="flex flex-col md:flex-row gap-10 justify-start">
            <PricingCard title="Nightly Rate" price="$405" description="2 night minimum" />
            <PricingCard title="Cleaning Fee" price="$100" description="per stay" />
            <PricingCard title="Dog Cleaning Fee" price="$75" description="per dog, per stay" />
        </div>
    );
}